export default __webpack_public_path__ + "static/media/exploded-view_sprite.8bebc5e0.png";